import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { TenantGroupAccessService } from '../../../../services/tenant-group-access.service';
import { ToastService } from '../../../../services/toast-service';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-grant-access-modal',
  templateUrl: './grant-access-modal.component.html',
  styleUrls: ['./grant-access-modal.component.scss']
})
export class GrantAccessModalComponent implements OnInit {
  accessForm!: FormGroup;
  saving = false;
  loading = false;

  employees: any[] = [];
  tenantGroups: any[] = [];

  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private accessService: TenantGroupAccessService,
    private toastService: ToastService,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.accessForm = this.fb.group({
      userEmail: [null, Validators.required],
      groupID: [null, Validators.required]
    });

    this.loadData();
  }

  loadData(): void {
    this.loading = true;

    // Hent gjeldende brukers e-post slik at vi kan filtrere bort selv-grant. Backend må også
    // håndheve dette, men frontend-filteret hindrer at admin uvitende klikker seg selv inn.
    let currentUserEmail = '';
    try {
      const stored = JSON.parse(localStorage.getItem('userData') || '{}') || {};
      currentUserEmail = (stored.userEmail || stored.userMail || '').toString().toLowerCase().trim();
    } catch { currentUserEmail = ''; }

    forkJoin({
      users: this.accessService.getTenantUsers('userFullname', 'asc', 0, 9999),
      groups: this.accessService.getAvailableGroups()
    }).subscribe({
      next: (response) => {
        if (response.users?.success && response.users.result?.rows) {
          const allUsers = response.users.result.rows || [];
          // Filter ut innlogget bruker — backend skal også avvise self-grant, men UI-filteret
          // er nyttig defense-in-depth mot at admin gir seg selv ekstra grupper i farten.
          this.employees = currentUserEmail
            ? allUsers.filter((u: any) => (u.userEmail ?? u.userMail ?? '').toString().toLowerCase().trim() !== currentUserEmail)
            : allUsers;
        }
        if (response.groups?.success) {
          this.tenantGroups = response.groups.result || [];
        }
        this.loading = false;
      },
      error: (error) => {
        console.error('Error loading data:', error);
        this.loading = false;
      }
    });
  }

  save(): void {
    if (this.accessForm.invalid) {
      Object.keys(this.accessForm.controls).forEach(key => {
        this.accessForm.controls[key].markAsTouched();
      });
      return;
    }

    this.saving = true;
    const formData = this.accessForm.value;

    this.accessService.grantAccess(formData.userEmail, formData.groupID).subscribe({
      next: (response) => {
        if (response?.success) {
          this.activeModal.close('granted');
        } else {
          this.toastService.show({
            type: 'error',
            data: [this.translateService.instant('EmployeeTenantAccess.grantFailed')]
          });
          this.saving = false;
        }
      },
      error: (error) => {
        console.error('Error granting access:', error);
        this.toastService.show({
          type: 'error',
          data: [this.translateService.instant('EmployeeTenantAccess.grantFailed')]
        });
        this.saving = false;
      }
    });
  }

  cancel(): void {
    this.activeModal.dismiss();
  }
}

